import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-header-alert',
  template: `
    <section class="top-app-alert" *ngIf="display">
      <p>
        <ng-content></ng-content>
      </p>
      <i class="pi pi-times" (click)="display = false"></i>
    </section>
  `,
  styles: [
    `
      .top-app-alert {
        background-color: #f43f5e;
        color: #fff;
        padding: 0.7rem 1.5rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        i {
          cursor: pointer;
          font-size: 0.8rem;
          background-color: rgba(255, 255, 255, 0.2);
          padding: 0.4rem;
          border-radius: 100px;
          transition: all 0.4s;
          &:hover {
            color: #f43f5e;
            background-color: #fff;
          }
        }
      }
    `,
  ],
})
export class HeaderAlertComponent {
  /**
   * @description
   * This is alert for messages like 'Your app is currently updating'...
   * This message will be displayed below the header and will only be seen by cms users
   */

  /**
   * * Inputs
   * @display Show/hide alert message
   */
  @Input() display: boolean;
}
